import React from "react";

import bkmLogo from "../img/festival/logos2026/BKM_de_v2__Web_farbig.svg";
import behoerdeLogo from "../img/festival/logos2026/Beh”rde_KuM.png";
import cssLogo from "../img/festival/logos2026/CSS_Logo_3_zeilig_Farbe.svg";
import fondsDaKuLogo from "../img/festival/logos2026/FondsDaKu_Logo_sw.png";
import hkLogo from "../img/festival/logos2026/HK_Lockup_RGB_Schwarz.svg";
import zeitLogo from "../img/festival/logos2026/ZEITStiftungBucerius_Logo_RGB.png";
import lichthofLogo from "../img/festival/logos2026/logo_lhtheater_18_rot.png";
import bamLogo from "../img/festival/logos2026/cooperations/BAM-Logo-Schwarz-Auf-Weiss.jpg";
import dfdkLogo from "../img/festival/logos2026/cooperations/DFDK_Wortmarke_CMYK_anthrazit.png";
import klangpolLogo from "../img/festival/logos2026/cooperations/KlangpolLogo1.jpg";
import mffmLogo from "../img/festival/logos2026/cooperations/mffm_farbe1.svg";
import rauteTracksLogo from "../img/festival/logos2026/cooperations/raute-tracks.jpg";
import spOrbitLogo from "../img/festival/logos2026/cooperations/SP_Orbit_Logo_schwarz_no_date (1).jpg";
import vamhLogo from "../img/festival/logos2026/cooperations/verband-fuer-aktuelle-Musik-Hamburg-logo-bt.jpg";
import fpavillonLogo from "../img/festival/logos2026/cooperations/FPavillon.png";
import hbSDtiftung from "../img/festival/logos2026/cooperations/Heinrich-Boell-Stiftung-Logo.jpg";

type FestivalLogo = {
  name: string;
  src: string;
  url?: string;
};

export type FestivalLogosBoardVariant = "default" | "cooperations";

const baseLogos2026: FestivalLogo[] = [

  {
    name: "Behörde für Kultur und Medien",
    src: behoerdeLogo,
    url: "https://www.hamburg.de/politik-und-verwaltung/behoerden/behoerde-fuer-kultur-und-medien",
  },
  {
    name: "Claussen-Simon-Stiftung",
    src: cssLogo,
    url: "https://www.claussen-simon-stiftung.de/de/",
  },
  {
    name: "Fonds DaKu",
    src: fondsDaKuLogo,
    url: "https://www.fonds-daku.de/",
  },
  {
    name: "BKM",
    src: bkmLogo,
    url: "https://www.kulturstaatsministerin.de/",
  },
  {
    name: "HK",
    src: hkLogo,
    url: "https://www.kulturstiftung-hh.de/"
  },
  {
    name: "ZEIT STIFTUNG BUCERIUS",
    src: zeitLogo,
    url: "https://www.zeit-stiftung-bucerius.de/",
  },
  {
    name: "Lichthof Theater",
    src: lichthofLogo,
    url: "https://www.lichthof-theater.de/",
  },
];

const cooperationsLogos2026: FestivalLogo[] = [
  {
    name: "BAM! Festival für freies Musiktheater",
    src: bamLogo,
    url:"https://bam-berlin.org/de"
  },
  {
    name: "Dachverband freie darstellende Künste Hamburg e.V.",
    src: dfdkLogo,
    url: "https://www.dfdk.de/de",
  },
  {
    name: "klangpol - Netzwerk Neue Musik Nordwest",
    src: klangpolLogo,
    url: "https://www.klangpol.de/",
  },
  {
    name: "Magazin für freies Musiktheater",
    src: mffmLogo,
    url:"https://mffmonline.com/"
  },
  {
    name: "Tracks - Festival für freies Musiktheater",
    src: rauteTracksLogo,
    url:"https://freiesmusiktheaterleipzig.de/tracks/"
  },
  {
    name: "ORBIT – Festival für aktuelles Musiktheater",
    src: spOrbitLogo,
    url:"https://orbit.cologne/"
  },
  {
    name: "Verband für aktuelle Musik Hamburg",
    src: vamhLogo,
    url: "https://www.vamh.de/",
  },

  {
    name: "FPavillon",
    src: fpavillonLogo,
    url:"https://fringify.hamburg/f-pavillon/"
  },
  {
    name: "Heinrich-Böll-Stiftung Hamburg",
    src: hbSDtiftung,
    url:"https://www.boell-hamburg.de/"
  },
];

type FestivalLogosBoardProps = {
  variant?: FestivalLogosBoardVariant;
};

const FestivalLogosBoard: React.FC<FestivalLogosBoardProps> = ({
  variant = "default",
}) => {
  const logos2026 =
    variant === "cooperations"
      ? [...baseLogos2026, ...cooperationsLogos2026]
      : baseLogos2026;

  return (
    <div
      className={`festival-logos-board ${
        variant === "cooperations" ? "festival-logos-board-cooperations" : ""
      }`}
      aria-label={
        variant === "cooperations"
          ? "Kooperationslogo-Board 2026"
          : "Förderlogo-Board 2026"
      }
    >
      {logos2026.map((logo) => {
      const tileClassName = logo.url
        ? "festival-logo-tile"
        : "festival-logo-tile festival-logo-tile-disabled";

      return logo.url ? (
        <a
          key={logo.name}
          className={tileClassName}
          href={logo.url}
          target="_blank"
          rel="noreferrer"
          aria-label={`${logo.name} Website öffnen`}
        >
          <img src={logo.src} alt={logo.name} className="festival-logo-image" />
        </a>
      ) : (
        <div key={logo.name} className={tileClassName} aria-label={logo.name}>
          <img src={logo.src} alt={logo.name} className="festival-logo-image" />
        </div>
      );
    })}
    </div>
  );
};

export default FestivalLogosBoard;
